import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { faPalette } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useFocusWithin } from "@vueuse/core";
import { BButton, BButtonGroup } from "bootstrap-vue";
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useMarkdown } from "@/composables/markdown";
import { useUid } from "@/composables/utils/uid";
import { useWorkflowStores } from "@/composables/workflowStores";
import { darkenedColors } from "./colors";
import { useResizable } from "./useResizable";
import { selectAllText } from "./utilities";
import ColorSelector from "./ColorSelector.vue";
import DraggablePan from "@/components/Workflow/Editor/DraggablePan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MarkdownComment',
    props: {
        comment: null,
        rootOffset: null,
        scale: null,
        readonly: { type: Boolean }
    },
    emits: ["change", "resize", "move", "pan-by", "remove", "set-color"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faTrashAlt, faPalette);
        const resizeContainer = ref();
        useResizable(resizeContainer, computed(() => props.comment.size), ([width, height]) => {
            emit("resize", [width, height]);
        });
        const textAreaId = useUid("textarea-");
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true, increaseHeadingLevelBy: 1 });
        const content = computed(() => {
            const renderedMarkdown = renderMarkdown(props.comment.data.text);
            const node = document.createElement("div");
            node.innerHTML = renderedMarkdown;
            // make all rendered text selectable by dragging
            const allChildren = node.querySelectorAll("*");
            Array.from(allChildren).forEach((child) => {
                child.classList.add("prevent-zoom");
            });
            return node.innerHTML;
        });
        const markdownTextarea = ref();
        function onClick() {
            if (!props.readonly && window.getSelection()?.toString() === "") {
                markdownTextarea.value?.focus();
            }
        }
        function onMove(position) {
            emit("move", [position.x, position.y]);
        }
        function onMouseup() {
            const element = markdownTextarea.value;
            if (element && element.value.trim() === "") {
                element.focus();
            }
        }
        const showColorSelector = ref(false);
        const rootElement = ref();
        const { focused } = useFocusWithin(rootElement);
        watch(() => focused.value, () => {
            if (!focused.value) {
                showColorSelector.value = false;
            }
        });
        function onSetColor(color) {
            emit("set-color", color);
        }
        function onTextChange() {
            const element = markdownTextarea.value;
            if (element && element.value !== props.comment.data.text) {
                emit("change", { text: element.value });
            }
        }
        const cssVariables = computed(() => {
            const vars = {};
            if (props.comment.color !== "none") {
                vars["--primary-color"] = darkenedColors[props.comment.color];
            }
            return vars;
        });
        const { commentStore } = useWorkflowStores();
        onMounted(() => {
            if (commentStore.isJustCreated(props.comment.id) && markdownTextarea.value) {
                selectAllText(markdownTextarea.value);
            }
        });
        const position = computed(() => ({ x: props.comment.position[0], y: props.comment.position[1] }));
        return { __sfc: true, props, emit, resizeContainer, textAreaId, renderMarkdown, content, markdownTextarea, onClick, onMove, onMouseup, showColorSelector, rootElement, focused, onSetColor, onTextChange, cssVariables, commentStore, position, FontAwesomeIcon, BButton, BButtonGroup, reactive, ColorSelector, DraggablePan };
    }
});
